import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_dealer = `${hostApi}/api/app/dealers`;

function getDealerList(params) {
    return Vue.prototype.$http.get(api_dealer, { params });
}

function getDealer(id) {
    return Vue.prototype.$http.get(`${api_dealer}/${id}`);
}

export {
    getDealerList,
    getDealer,
};
